import React, { useEffect, useState } from "react";
import "./index.scss";
import PageHeader from "../../../adminCompenents/listComponents/Layout";
import CardContainer from "../../../adminCompenents/listComponents/UI/CardContainer";
import ExportButton from "../../../adminCompenents/listComponents/UI/ExportButton";
import AddButton from "../../../adminCompenents/listComponents/UI/AddButton";
import SearchFilterBar from "../../../adminCompenents/listComponents/UI/SearchFilterBar";
import DataTable from "../../../adminCompenents/listComponents/UI/DataTable";
import DataCards from "../../../adminCompenents/listComponents/UI/DataCards"; // ✅ Nouveau
import Pagination from "../../../adminCompenents/listComponents/UI/Pagination";
import UserService from "../../../services/user";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { exportCSV } from "../../../adminCompenents/utils";
import DrawerForm from "../../../adminCompenents/listComponents/UI/DrawerForm";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import { useNavigate } from "react-router-dom";
import { FiCheckSquare } from "react-icons/fi";
import { FaBan } from "react-icons/fa";

const userService = new UserService();

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 5;
  const [filters, setFilters] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const navigate = useNavigate();
  const filterFields = [
    { name: "email", label: "Email", placeholder: "Search email..." },
  ];

  // 👉 Responsive detection
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filtered = users.filter((p) => {
    return (
      p.name?.toLowerCase().includes(search.toLowerCase()) &&
      (filters?.email
        ? p.email.toLowerCase().includes(filters.email.toLowerCase())
        : true)
    );
  });

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(userId) {
    return `${apiUrl}/users/${userId}/image`;
  }

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await userService?.getAllusers();
      setUsers(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);
  const handleStatus = async (id) => {
    setIsLoading(true);

    try {
      const response = await userService?.toggleUserStatus(id);
      // vérifier la vraie structure
      const updatedUser = response?.data || response;

      setUsers((prev) => prev.map((u) => (u._id === id ? updatedUser : u)));
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      header: "Nom et prénom",
      accessor: "name",
      Cell: (value, row) => (
        <div className="d-flex align-items-center">
          <img
            src={getImageURL(row?._id)}
            alt={row.name}
            className="product-img me-2"
          />
          {value}
        </div>
      ),
    },
    { header: "Email", accessor: "email" },
    { header: "Role", accessor: "role" },
    {
      header: "Status",
      accessor: "status",
      Cell: (value) => (
        <span
          className={`badge ${
            value === "enabled" ? "bg-successstyle" : "bg-dangerstyle"
          }`}>
          {value === "enabled" ? "Active" : "Inactive"}
        </span>
      ),
    },
    { header: "Created At", accessor: "createdAt" },
  ];

  const rowActions = (row) => [
    {
      label: "Edit",
      onClick: () => {
        setEditUser({
          ...row,
          image: getImageURL(row._id), // ✅ transformer en URL utilisable
        }); // charger les données existantes
        setShowDrawer(true);
      },
    },
    {
      label: (
        <label className="mx-1">
          {row.status === "enabled" ? (
            <FaBan style={{ color: "#EE0202" }} />
          ) : (
            <FiCheckSquare style={{ color: "#00AC0E" }} />
          )}
        </label>
      ),
      onClick: async () => {
        handleStatus(row._id);
      },
    },
  ];
  const [showDrawer, setShowDrawer] = useState(false);

  const fields = [
    {
      name: "name",
      label: "Nom d'utilisateur",
      placeholder: "Entrez le nom",
      required: true,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Entrez l'email",
      required: true,
    },

    { name: "image", label: "Photo de profil", type: "file" },
  ];
  const handleSubmit = async (formData, editUser = null) => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      if (editUser) {
        // ✅ Mode édition

        const updatedUser = await userService.editUsers(
          editUser._id,
          formDataToSend
        );
        console.log('"updatedUser', updatedUser);

        // Remplace l'utilisateur modifié dans la liste
        setUsers((prev) =>
          prev.map((u) => (u._id === editUser._id ? updatedUser.data.data : u))
        );
        console.log(users);
        showSuccessToaster("Utilisateur modifié avec succès.");
      } else {
        // ✅ Mode création
        const newUser = await userService.createUsers(formDataToSend);

        setUsers((prev) => [...prev, newUser.data]);
        showSuccessToaster("Utilisateur créé avec succès.");
      }

      setShowDrawer(false);
      setEditUser(null); // reset après soumission
    } catch (error) {
      showErrorToaster(
        error.response?.data?.message ||
          "Une erreur est survenue, veuillez réessayer."
      );
    }
  };

  return (
    <div>
      <PageHeader
        title="Utilisateurs"
        breadcrumb={[{ label: "Accueil", href: "/" }, { label: "Utilisateurs" }]}
      />

      <CardContainer>
        <div className="d-flex justify-content-between align-items-center mb-3 m-4">
          <h5 className="title-liste"> Lists des utilisateurs</h5>
          <div className="d-flex gap-2">
            <ExportButton
              onClick={() => {
                exportCSV(
                  ["name", "email", "role", "status"],
                  paginated,
                  "users.csv"
                );
              }}
            />
            <AddButton label="Users" onClick={() => setShowDrawer(true)} />
          </div>
        </div>

        <hr className="hr-table" />
        <SearchFilterBar
          fields={filterFields}
          onSearch={setSearch}
          onFilter={(f) => setFilters(f)}
        />
        <hr className="hr-table" />

        {/* ✅ Responsive : Table ou Cards */}
        {isMobile ? (
          <DataCards
            columns={columns}
            data={paginated}
            keyField="id"
            rowActions={rowActions}
          />
        ) : (
          <DataTable
            columns={columns}
            data={paginated}
            keyField="id"
            rowActions={rowActions}
          />
        )}

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </CardContainer>
      <DrawerForm
        show={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setEditUser(null); // reset si on était en mode édition
        }}
        title={editUser ? "Modifier un utilisateur" : "Créer un utilisateur"}
        fields={fields}
        initialData={editUser} // 👉 nouveau : permet de pré-remplir les champs si on édite
        onSubmit={(data) => handleSubmit(data, editUser)}
      />
    </div>
  );
};

export default UsersPage;
